import { ProductKind } from "@/web-client/api";
import { FC } from "react";
import { ProductSearchQueryParameter } from "@/types/ProductSearchQueryParameter";
import ModalSearchProductChild from "@/features/product_variation/components/ModalSearchProductChild";
import ModalSearchContainer from "@/components/ModalSearchWrapper";

interface Props {
  closeHandler: () => void;
  query: ProductSearchQueryParameter;
  kind?: ProductKind;
}

const ModalSearchMaker: FC<Props> = ({ closeHandler, query, kind }) => {
  return (
    <ModalSearchContainer title="検索条件の追加" closeHandler={closeHandler}>
      <ModalSearchProductChild
        kind={kind}
        query={query}
        closeHandler={closeHandler}
      />
    </ModalSearchContainer>
  );
};
export default ModalSearchMaker;
